import React, {Component} from 'react';
import {Col, Row, Collapse, Button, Form, Input, Select, DatePicker, Alert} from 'antd'
import moment from 'moment';
const Panel = Collapse.Panel;
const Item = Form.Item;
const {RangePicker} = DatePicker;

class Params extends Component {



  constructor(props) {
    super(props);
    this.getReportResults = this.props.services.getReportResults.bind(this);
    this.getDynamicValues = this.props.services.getDynamicValues.bind(this);

    this.state={
      firstTime:false
    }
  }

  componentDidMount() {
    this.state.firstTime = true;
  }

  componentDidUpdate(){
    if(this.props.reportParams){
    if(Object.keys(this.props.reportParams).length>1 && this.state.firstTime &&  Object.keys(this.props.form.getFieldsValue()).length>0){
      let filteredParams = {};
      Object.keys(this.props.reportParams).forEach((param)=>{

        if(param!='reportId'){
          if((this.props.reportMetaData.params.find((element)=> element.name==param)) &&
             (this.props.reportMetaData.params.find((element)=> element.name==param)).type=='DATE'){
             if(this.props.reportParams[param]){
              filteredParams[param] = moment(this.props.reportParams[param]);
            }
          } else {
            filteredParams[param] = this.props.reportParams[param];
        }
        }
      })


      this.props.form.setFieldsValue(filteredParams);
      this.state.firstTime=false;
  }
}

  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let filteredValues = {};
        Object.keys(values).forEach((key) => {
          if(values[key]){


            filteredValues[key] = values[key];
          } else {
            filteredValues[key] = null;
          }
        }
      )
        filteredValues["TIMEZONEOFF"] = moment().local().format('ZZ');
        if (this.props.orgId !== -1) {
          filteredValues["ORG_ID"] = this.props.orgId;
        }

        this.getReportResults(this.props.reportMetaData.id, filteredValues);
      }
    });
  }

  onSelectChange = (fieldName) => {
    const { reportMetaData } = this.props;
    const { getFieldsValue } = this.props.form;
    const getDynamicValues = this.getDynamicValues;
   setTimeout(function(){
    reportMetaData.params.map(param=>{
      if(fieldName.fieldName==param.depends){
        getDynamicValues(reportMetaData.id, param.name, getFieldsValue())

      }
    })
  } , 0)
  }

  handleReset = () => {
    this.props.form.resetFields();
  }

  genarateOptions(choices){
    return choices.map(choice => {
      return <Option key={choice.name} value={choice.name}>{choice.value}</Option>;
    })
  }



  filterInputMapper(type, fieldName, description, required, defaultValue, choices, getFieldDecorator) {
      switch (type) {
        case "STRING":
          return (getFieldDecorator(fieldName, {
            rules: [{
              required: required, message: `Please input ${description}`,
            }],
            initialValue: defaultValue
          }
        )(<Input style={{
            width: "75%"
          }}/>));
        case "SELECT":
          return  (getFieldDecorator(fieldName, {
            rules: [{
              required: required, message: `Please input ${description}`,
            }],
            initialValue: defaultValue
          })(<Select showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} allowClear={true} onChange={() => this.onSelectChange({fieldName})} style={{
              width: "75%"
            }}>
            {this.genarateOptions(choices)}
          </Select>));
          case "SUBSELECT":
            return  (getFieldDecorator(fieldName, {
              rules: [{
                required: required, message: `Please input ${description}`,
              }],
              initialValue: defaultValue
            })(<Select showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} allowClear={true} onChange={() => this.onSelectChange({fieldName})} style={{
                width: "75%"
              }}>
              {this.genarateOptions(choices)}
            </Select>));
        case "DATE":
          return  (getFieldDecorator(fieldName, {
            rules: [{
              required: required, message: `Please input ${description}`,
            }],
            initialValue: defaultValue?moment(defaultValue):null
          })(<DatePicker  allowClear={true}  style={{
              width: "75%"
            }}></DatePicker>));
       case "NUMBER":
              return  (getFieldDecorator(fieldName, {
                rules: [{
                  required: required, message: `Please input ${description}`,
                }, {
                  type: "integer", message: `${description} must be a number`, transform(value) {
                    value = +value;
                    return value}
                }],
                initialValue: defaultValue
              })(<Input style={{
                  width: "75%"
                }}/>));
        case "RANGE":
          return (getFieldDecorator(fieldName, {
            rules: [{
              required: required, message: `Please input ${description}`,
            }],
          })(<RangePicker defaultValue={undefined} allowClear={true}  style={{
              width: "75%"
            }}></RangePicker>));
        default: //no op
      }
  }

  getParamsPanel(getFieldDecorator, formItemLayout){
    if(this.props.reportMetaData.params.length>0){
      return(<Collapse defaultActiveKey={['1']}>
        <Panel header="Search Parameters" key="1">
        <Form onSubmit={this.handleSubmit}><Row>
        <Col span={23}>
        {this.getParams(getFieldDecorator, formItemLayout)}
        </Col>
        </Row>
        <Row>
        <Col span={23}>
        <Item {...formItemLayout}> <div style={{width: "100%",  textAlign: "center"}}>
           <Button type="primary" htmlType="submit">Submit</Button>
           <Button type="primary" style={{ marginLeft: 8 }} onClick={this.handleReset}>Reset</Button>
           </div>
         </Item>
         </Col>
         </Row>
      </Form>
      </Panel>
      </Collapse>)
    }
  }

  getParams(getFieldDecorator, formItemLayout){
    if(this.props.reportMetaData && this.props.reportMetaData.params){
     let children = [];
     this.props.reportMetaData.params.sort((a, b) => a.ordinal - b.ordinal).map(param=>{
       children.push(<Item {...formItemLayout} label={param.description}>

          {this.filterInputMapper(param.type, param.name, param.description, param.required, param.defaultValue, param.choices, getFieldDecorator)}

         </Item>
       )
     })

    if(this.props.reportMetaData.numCols=='2'){
      let content = [];
      let cols = [];
      children.forEach((child, i) => {
         if((i%2)==0){
           cols = [];
           cols.push(<Col span={11}>{child}</Col>)
           if(i==(children.length-1)){
             content.push(<Row>{cols}</Row>);
           }
         } else {
           cols.push(<Col span={11}>{child}</Col>)
           content.push(<Row>{cols}</Row>);
         }
      })
      return content
   } else {
     let content = [];
     children.forEach((child, i) => {
          content.push(<Row><Col span={23}>{child}</Col></Row>)
     })
     return content
   }
 }
 }

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 8 },
        sm: { span: 8 },
        style: { 'white-space':'pre-wrap'
        }

      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 },
      },
    };

    if(this.props.reportMetaData && !this.props.loadingParams){
      return (<div>
        <Collapse defaultActiveKey={['1']}>
        <Panel header={
          this.props.reportMetaData.grouping + ' / ' + this.props.reportMetaData.name
        } key="1">
        <Row>
          <Col span="5">
            Description:
          </Col>
          <Col span="18" style={{'white-space':'pre-wrap'}}>
           {this.props.reportMetaData.description}
          </Col>
        </Row>
        <Row>
          <Col span="5">
            Notes:
          </Col>
          <Col span="18" style={{'white-space': 'pre-wrap'}}>
           {this.props.reportMetaData.notes}
          </Col>
        </Row>
      </Panel>
      </Collapse>

      {this.getParamsPanel(getFieldDecorator, formItemLayout)}
    </div>)
  } else if(this.props.loadingParams=="failure") {
   return (<div><Alert type="error" message="Error" description="Error Loading Report"></Alert></div>)
  } else {
    return (<div/>)

  }
}
}
export default Form.create()(Params);
